import { logger } from "../../../utils/logger.es.js";
import { TIME_THRESHOLD, EH_PREVIOUS_VISIT_ID, EH_VISIT_ID, LONG_COOKIE_EXPIRATION, VISIT_ID, VISIT_ID_TS } from "./constants.es.js";
import { v as v4 } from "../../../v4-88c20f3b.js";
const timeExpiredCheck = (timeDifference, visitId, cookieOptions, cookieHandler) => {
  if (timeDifference > TIME_THRESHOLD) {
    const newVisitId = v4();
    cookieHandler.setCookie(
      {
        [EH_PREVIOUS_VISIT_ID]: visitId,
        [EH_VISIT_ID]: newVisitId
      },
      [{ ...cookieOptions, expires: LONG_COOKIE_EXPIRATION }, cookieOptions]
    );
    return newVisitId;
  } else {
    return visitId;
  }
};
const getUrlVisitId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let urlVisitId = urlParams.get(VISIT_ID);
  let urlVisitIdTs = urlParams.get(VISIT_ID_TS);
  if (urlVisitId) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(urlVisitId)) {
      logger.error("Invalid URL VisitId format");
      urlVisitId = null;
      urlVisitIdTs = null;
      return { urlVisitId: null, urlVisitIdTs: null };
    }
  }
  return { urlVisitId, urlVisitIdTs };
};
export {
  getUrlVisitId,
  timeExpiredCheck
};
